import type * as React from "react";
import { useServerSideContent } from "../hooks/useServerSideContent";
import { memo } from "react";
import RenderServerSideContent from "./RenderServerSideContent";
import { useEffect, useEffectEvent } from "react";

interface Props {
  selector: string;
  className?: string;
  transformNode?: (node: Element) => void;
}

const SimpeRenderServerSideContent: React.FC<Props> = ({ selector, className, transformNode }) => {
  const { element } = useServerSideContent(selector);

  // react-doctor:SYNC-EXTERNAL: transformNode fires when the server-rendered DOM node becomes available —
  // the effect IS the availability seam (no user event exists to host the callback).
  // The call goes through a useEffectEvent so callback identity churn cannot re-run it.
  const applyTransformNode = useEffectEvent((node: Element) => transformNode?.(node));
  useEffect(() => {
    if (element) {
      applyTransformNode(element);
    }
  }, [element]);

  if (!element) {
    return null;
  }

  return <RenderServerSideContent className={className} content={element} />;
};

export default memo(SimpeRenderServerSideContent);
